module.exports = __webpack_public_path__ + "img/23.c541794c.jpg";